/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';

import Step1 from './Step1';
import Step3 from './Step3';
import Step4 from './Step4';
import Card from '../Card';
import Store from '../Store';
import useCurrentUser from '../useCurrentUser';
import VerifyAccount from '../VerifyAccount';

let DeviceSetup = ({ viewer }) => {
  const [currentUser] = useCurrentUser();
  let [activeStep, setActiveStep] = React.useState(0);
  let [response, setResponse] = React.useState(null);
  let [responseLoading, setResponseLoading] = React.useState(false);

  React.useEffect(() => {
    const show2 = viewer?.devices?.edges?.length > 0;
    if (show2) {
      setActiveStep(1);
      return;
    }
  }, [viewer]);

  let onStep = step => {
    setActiveStep(step);
  };

  let onResponse = (resp, err) => {
    console.log('resp', resp, err);
    setResponseLoading(false);
    if (err) {
      setActiveStep(1);
      Store.onFailure(err);
      return;
    }
    console.log('setREsponse');
    setResponse(resp);
  };

  let onSend = () => {
    setResponseLoading(true);
    setResponse(null);
    setActiveStep(2);
  };

  // Calculate step indices and display numbers
  const steps = [];
  let displayNum = 1;

  if (currentUser.isAnonymous) {
    steps.push({
      index: 0,
      displayNum: displayNum++,
      title: 'Choose an account provider',
      content: <VerifyAccount />,
    });
  }
  steps.push({
    index: currentUser.isAnonymous ? 1 : 0,
    displayNum: displayNum++,
    title: 'Install and login on mobile app',
    content: <Step1 onStep={onStep} />,
  });
  steps.push({
    index: currentUser.isAnonymous ? 2 : 1,
    displayNum: displayNum++,
    title: 'Send interactive message',
    content: <Step3 viewer={viewer} onSend={onSend} onResponse={onResponse} />,
  });
  steps.push({
    index: currentUser.isAnonymous ? 3 : 2,
    displayNum: displayNum++,
    title: 'Select action',
    content: <Step4 response={response} responseLoading={responseLoading} />,
    isLast: true,
  });

  const renderStep = (step, isLast = false) => {
    const isActive = activeStep >= step.index;
    const isCompleted = activeStep > step.index;

    return (
      <div key={step.index} className="flex gap-4">
        <div className="flex flex-col items-center">
          <div
            className={`w-8 h-8 rounded-full flex items-center justify-center ${
              isActive ? 'bg-primary text-primary-foreground' : 'bg-gray-200'
            }`}
          >
            {isCompleted ? '✓' : step.displayNum}
          </div>
          {!isLast && isCompleted && (
            <div className="w-0.5 h-full bg-primary" />
          )}
        </div>
        <div className="flex-1">
          <h3 className="font-semibold mb-2">{step.title}</h3>
          {isActive && step.content}
        </div>
      </div>
    );
  };

  return (
    <Card className="device-setup-card p-4">
      <h2 className="text-2xl font-semibold mb-2">Setup your device</h2>
      <p className="mb-4">
        Follow the steps below to start receiving notifications on your Android
        or iOS device
      </p>
      <div className="space-y-6">
        {steps.map((step, idx) => renderStep(step, idx === steps.length - 1))}
      </div>
    </Card>
  );
};

DeviceSetup = createFragmentContainer(DeviceSetup, {
  viewer: graphql`
    fragment DeviceSetup_viewer on User {
      id
      email
      accessToken {
        secret
      }
      devices(first: 100) @connection(key: "Account_devices") {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  `,
});

export default DeviceSetup;
